// application/use-cases/simple/GetSimplesUseCase.ts

import type { Simple } from '@/domain/entities/simple';
import type { ISimpleRepository } from '@/domain/repositories/ISimpleRepository';

export class GetSimplesUseCase {
  constructor(
    private readonly repository: ISimpleRepository
  ) {}

  async execute(
    table: string
  ): Promise<Simple[]> {
    return this.repository.findAll(table);
  }
}